import "./index.css";
import Button from "@mui/material/Button";
// import AlertDialogForm from "../SwitchOnApprovalList/SwitchOnApprovalDialog";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axios from "axios";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

import {
  VAVE,
  GETREASSIGNIL1PDLISTSOURCING,
  GETREASSIGNIL1PDLIST,
  DOWNLOADUPLOADEDUSERFILE
} from "../../../Pages/AppConstant";
import { sourcingEmpIds } from "../switch_on_userlist";
import loadergif from "../../../assets/images/BG-switch loader_2.gif";


import { Pagination, Stack } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
function SwitchOnAssignedByPD() {
  const [searchQuery, setSearchQuery] = useState("");
    const [allIdeas, setAllIdeas] = useState([]);
  const [ideaListByEmpId, setIdeaListByEmpId] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(ideaListByEmpId.length / itemsPerPage);
  const [viewMoreOpenDialog, setViewMoreOpenDialog] = useState(false);
  const [selectedIdea, setSelectedIdea] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [isloading, setIsloading] = useState(false);
  const currentEmpId = localStorage.getItem("empid");

  const handleViewMore = (idea) => {
    setSelectedIdea(idea);
    setViewMoreOpenDialog(true);
  };

  const handleButtonClick = (filter) => {
    setSelectedFilter(filter);
    setCurrentPage(1);
    handleFilter(filter);
  };
  
  const handleViewMoreCloseDialog = () => {
    setViewMoreOpenDialog(false);
    setSelectedIdea(null);
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "accepted":
        return "green";
      case "rejected":
        return "red";
      case "inprogress":
        return "orange";
      default:
        return "gray";
    }
  };

  useEffect(() => {
    fetchIdeas();
  }, []);


const fetchIdeas = async () => {
   const formData = new FormData();
    const currentEmpId = localStorage.getItem("empid") || "";

    formData.append("empids", currentEmpId);

    try {
      const url = sourcingEmpIds.includes(currentEmpId)
        ? GETREASSIGNIL1PDLISTSOURCING
        : GETREASSIGNIL1PDLIST;

      const response = await axios.post(VAVE + url, formData);
    const ideas = response.data.data || [];

      // Apply filter based on il1status


    setAllIdeas(ideas);
    handleFilter("All", ideas); // Initial filter
  } catch (error) {
    console.error("Error fetching ideas:", error);
  }
};



const handleFilter = (filter, data = allIdeas) => {
  const currentEmpId = localStorage.getItem("empid") || "";

  const filtered =
    filter === "All"
      ? data
      : sourcingEmpIds.includes(currentEmpId)
      ? data.filter(
          (idea) =>
            idea.il1_sourcing_status?.toLowerCase() === filter.toLowerCase()
        )
      : data.filter(
          (idea) =>
            idea.il1_pd_status?.toLowerCase() === filter.toLowerCase()
        );

  setIdeaListByEmpId(filtered);
};



  const filteredIdeas = ideaListByEmpId.filter((item) => {
    const query = searchQuery.toLowerCase();
    return Object.values(item).some((value) =>
      String(value).toLowerCase().includes(query)
    );
  });

  const paginatedIdeas = filteredIdeas.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const downloadUploadedUserDocApi = (request) => {
    setIsloading(true);
    axios({
      method: "post",
      url: VAVE + DOWNLOADUPLOADEDUSERFILE,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { idea_id: request.id_x },
      responseType: "blob",
    })
      .then((response) => {
        if (response.data.size === 14) {
          alert("No Data Available");
          setIsloading(false);
          return;
        }

        const contentType =
          response.headers["content-type"] || "application/pdf";
        const disposition = response.headers["content-disposition"];
        let filename = `Idea_${request.idea_unique_id}_User_Document.pdf`;

        const blob = new Blob([response.data], { type: contentType });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up
        URL.revokeObjectURL(url);
        setIsloading(false);
      })
      .catch((error) => {
        window.open(selectedIdea.filepath, "_blank");
        setIsloading(false);
      });
  };

  return (
    <div className="container mt-2">
      {isloading ? (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.3)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 9999,
                }}
              >
                <div className="loadergif">
                  <img src={loadergif} alt="Loading..." />
                </div>
              </div>
            ) : (
              ""
            )}
      <div className="d-flex flex-row align-items-center gap-3 flex-wrap pb-3 pt-4">
        <div className="d-flex align-items-center">
          <label className="me-2">Search</label>
          <input
            type="text"
            className="form-control"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setCurrentPage(1);
            }}
            style={{ width: "200px" }}
          />
        </div>
        <div className="d-flex gap-2">
          <Button
            variant="contained"
            color={selectedFilter === "All" ? "success" : "primary"}
            onClick={() => handleButtonClick("All")}
          >
            All
          </Button>
          <Button
            variant="contained"
            color={selectedFilter === "inprogress" ? "success" : "primary"}
            onClick={() => handleButtonClick("inprogress")}
          >
            Pending
          </Button>

          <Button
            variant="contained"
            color={selectedFilter === "accepted" ? "success" : "primary"}
            onClick={() => handleButtonClick("accepted")}
          >
            Accepted
          </Button>
          <Button
            variant="contained"
            color={selectedFilter === "rejected" ? "success" : "primary"}
            onClick={() => handleButtonClick("rejected")}
          >
            Rejected
          </Button>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-striped custom-table">
          <thead className="thead-dark">
            <tr>
              <th>SW Id</th>
                 {selectedFilter === "All" && <th>Status</th>}
              <th>Assigned To</th>
              <th>Idea Category</th>
              <th>Part No</th>
              <th>Savings</th>
              {/* <th>Aggregate</th> */}
              <th>Sub Variant</th>
              <th>View More</th>
            </tr>
          </thead>
          <tbody>
            
              {paginatedIdeas.length === 0 ? (
              <tr>
                <td colSpan="8" className="text-center py-4">
                  No ideas found
                </td>
              </tr>
            ) : (
            paginatedIdeas.map((req, index) => (
              <tr key={req.id}>
                <td>{req.idea_unique_id}</td>
                 {selectedFilter === "All" && (
                  <td style={{ cursor: "pointer" }}>
                    <span
                      title={req.il1_pd_status}
                      style={{
                        display: "inline-block",
                        width: "18px",
                        height: "18px",
                        borderRadius: "50%",
                        backgroundColor: getStatusColor(req.il1_pd_status),
                        marginRight: "8px",
                      }}
                    ></span>
                  </td>
                )}
                {sourcingEmpIds.includes(currentEmpId) ? (
                  <td> {req.il1_sourcing_assigned}</td>
                ) : (
                  <td> {req.il1_pd_assigned}</td>
                )}
                <td>{req.idea_category}</td>
                <td>{req.partno}</td>

                <Tooltip title={req.benefit || ""} arrow>
                  <td>
                    {req.benefit?.slice(0, 15)}
                    {req.benefit?.length > 15 ? "..." : ""}
                  </td>
                </Tooltip>

                {/* <td>{req.idea_effective}</td> */}

                <td>{req.subvarient}</td>

                <td
                  style={{ cursor: "pointer" }}
                  onClick={() => handleViewMore(req)}
                >
                  <FormatListBulletedIcon />
                </td>
              </tr>
            )))}
          </tbody>
        </table>
      </div>

      {/* Dialog for View More */}
      <Dialog
        open={viewMoreOpenDialog}
        onClose={handleViewMoreCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Idea Details</DialogTitle>
        <DialogContent>
          {selectedIdea && (
            <Grid container spacing={2}>
              {/* Left Column */}
              <Grid item xs={10} sm={6}>
                <Typography variant="body1">
                  <strong>SW Id:</strong>{" "}
                  {selectedIdea.idea_unique_id}
                </Typography>
                {/* <Typography variant="body1">
                  <strong>Status:</strong>{" "}
                  <span style={{ color: getStatusColor(selectedIdea.status) }}>
                    {selectedIdea.status}
                  </span>
                </Typography> */}
                <Typography variant="body1">
                  <strong>Idea Category:</strong> {selectedIdea.idea_category}
                </Typography>
                <Typography variant="body1">
                  <strong>Part No:</strong> {selectedIdea.partno}
                </Typography>
                <Typography variant="body1">
                  <strong>Description:</strong> {selectedIdea.part_description}
                </Typography>
                <Typography variant="body1">
                  <strong>Proposed Idea:</strong> {selectedIdea.proposed_idea_x}
                </Typography>
                <Typography variant="body1">
                  <strong>Current Condition:</strong>{" "}
                  {selectedIdea.current_condition}
                </Typography>
                     {sourcingEmpIds.includes(currentEmpId) ? (
                  <Typography variant="body1">
                   <strong>Comments:</strong>   {selectedIdea.il1_sourcing_comment}
                  </Typography>
                ) : (
                  <Typography variant="body1">
                    <strong>Comments:</strong> {selectedIdea.il1_pd_comment}
                  </Typography>
                )}
              </Grid>
              {/* Right Column */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <strong>Savings:</strong> {selectedIdea.benefit}
                </Typography>
                <Typography variant="body1">
                  <strong>Aggregate:</strong> {selectedIdea.idea_effective}
                </Typography>
                <Typography variant="body1">
                  <strong>Model:</strong> {selectedIdea.model}
                </Typography>
                <Typography variant="body1">
                  <strong>Variant:</strong> {selectedIdea.varient}
                </Typography>

                <Typography variant="body1">
                  <strong>Sub Variant:</strong> {selectedIdea.subvarient}
                </Typography>
                <Typography variant="body1">
                  <strong>Domain:</strong> {selectedIdea.domain}
                </Typography>
                <Typography variant="body1">
                  <strong>Function:</strong> {selectedIdea.function}
                </Typography>
                <Typography variant="body1">
                  <strong>Location:</strong> {selectedIdea.location}
                </Typography>
           
                <Typography variant="body1">
                  <strong>Document:</strong>{" "}
                  {selectedIdea.filepath ? (
                    <button
                    style={{
                        cursor: "pointer",
                        color: "blue",
                        border: "transparent",
                        background: "transparent",
                      }}
                      onClick={() => downloadUploadedUserDocApi(selectedIdea)}
                    >
                      Download File
                    </button>
                  ) : (
                    "No File"
                  )}
                </Typography>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleViewMoreCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Stack alignItems="center" marginTop={1} color="white">
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(event, value) => setCurrentPage(value)}
          color="primary"
          variant="outlined"
          shape="circular"
          sx={{
            "& .MuiPaginationItem-root": {
              color: "black",
              borderColor: "black",
              backgroundColor: "white",
            },
            "& .Mui-selected": {
              backgroundColor: "green",
              color: "white",
            },
          }}
        />
      </Stack>
    </div>
  );
}

export default SwitchOnAssignedByPD;
